import { gql } from "gql";

export const GET_MY_POSTS = gql(/* GraphQL */ `
  query GetMyPosts($filter: MyPostFilter, $page: PageRequest) {
    getMyPosts(filter: $filter, page: $page) {
      content {
        ...PostCard
      }
      total
    }
  }
`);
